
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionComponent } from '../../components/section/section.component';
import { LinkSection, toPlainLink } from '../../types/link';

import { InnerSection, InnerSectionAttributes, Section, SectionAttributes } from '../../../app/types/section';
import { FigureImageSection } from '../image-collection/image-collection.component';
import { AspectRatio, RouterOrExternalLinkDirective } from '@knorr-bremse-portals/ngx-components';
import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { imageToPicture } from '../../../app/components/plain-image/plain-image.component';
import { OgImageDirective } from '../../../app/directives/og-image.directive';
import { iconArrowsRight } from '@knorr-bremse-portals/icons';
import { IconComponent } from '@knorr-bremse-portals/ngx-components/components/icon';
import { OverlayFigureComponent } from '@knorr-bremse-portals/ngx-components/components/overlay-figure';
import { PictureComponent } from '@knorr-bremse-portals/ngx-components/components/picture';
import { LineClampComponent } from '@knorr-bremse-portals/ngx-components/components/line-clamp';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

type IconSection = InnerSection<
  {
    src: string;
    alt: string;
  } & InnerSectionAttributes,
  [
    'src',
  ],
  'icon'
>;

type TeaserIconLinkSection = InnerSection<
  {
    link: LinkSection;
    teaserText: string;
    media: {
      image?: IconSection;
    };
  } & InnerSectionAttributes,
  [
    'media',
    'link',
    'teaserText',
  ],
  'teaser-icon-link'
>;

type TeaserOverviewSection = Section<
  {
    numColumns: 12 | 8;
    medium: FigureImageSection;
    items: TeaserIconLinkSection[];
    topic: string;
  } & SectionAttributes,
  [
    'numColumns',
    'medium',
    'topic',
    'items',
    'teaserText',
    'url',
  ],
  'teaser-overview'
>;

@Component({
    selector: 'section[app-teaser-overview]',
    styleUrls: ['./teaser-overview.component.scss'],
    templateUrl: './teaser-overview.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        EditorIdDirective,
        OgImageDirective,
        OverlayFigureComponent,
        PictureComponent,
        RouterOrExternalLinkDirective,
        IconComponent,
        LineClampComponent,
        FsButtonComponent,
    ],
})
export class TeaserOverviewComponent extends SectionComponent<TeaserOverviewSection> {

  protected imageToPicture = imageToPicture;
  protected aspectRatio = AspectRatio.Standard;
  protected iconLink = iconArrowsRight;
  protected toPlainLink = toPlainLink;

}
